module.exports = __webpack_public_path__ + "static/img/7.2.a7f8b23.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/7.2.png
// module id = HJab
// module chunks = 0